import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Modals} from "../../component";
import {declineCase} from "../../vendors/actions/case";
import {showRejectCaseModal} from "../../vendors/actions/modals";

interface OwnProps {

}

interface ConnectStateProps {
}

interface ConnectDispatchProps {
    showRejectCaseModal: (bool: boolean) => void
    declineCase: (case_uid: string) => void
}

const CancelCase = (props: any) => {
    const {caseRejectModal} = props.Modals,
        split = window.location.pathname.split('/'),
        case_uid = split[split.length - 1],
        closeModal = (): void => props.showRejectCaseModal(false),
        declineCase = (): void => props.declineCase(case_uid),
        description: any = <span className='m-0'>Rejecting the work product and/or the services means the work product and/or the services
            submitted by the lawyer do not meet the requirements outlined by you.<br/>
            <span className='mt-2 d-block'>Your request will be reviewed within 24 hours.</span></span>;

    return caseRejectModal ? (
        <Modals.Danger open={true}
                       cancelable={{
                           buttonTitle: 'Never Mind',
                           action: closeModal
                       }}
                       submit={{
                           buttonTitle: 'Reject',
                           action: declineCase
                       }}
                       icon={'times'}
                       description={description}/>
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Modals} = state;
    return {Modals}
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        showRejectCaseModal: (data: boolean) => dispatch(showRejectCaseModal(data)),
        declineCase: (data: string) => dispatch(declineCase(data))
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CancelCase));


